import ReportResults from "./report-results.jsx";

export default ReportResults;
